import { buildModelManager } from "../builder.js";
const DefaultGaiaWebhookSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  customerId: true,
  data: true,
  isProcessed: true,
  jwt: true,
  updatedAt: true
};
const modelApiIdentifier = "gaiaWebhook";
const pluralModelApiIdentifier = "gaiaWebhooks";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultGaiaWebhookSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultGaiaWebhookSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultGaiaWebhookSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultGaiaWebhookSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultGaiaWebhookSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultGaiaWebhookSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultGaiaWebhookSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createGaiaWebhook",
    operationReturnType: "CreateGaiaWebhook",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      gaiaWebhook: { required: false, type: "CreateGaiaWebhookInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultGaiaWebhookSelection
  },
  {
    type: "action",
    operationName: "bulkCreateGaiaWebhooks",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateGaiaWebhooksInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultGaiaWebhookSelection
  },
  {
    type: "action",
    operationName: "updateGaiaWebhook",
    operationReturnType: "UpdateGaiaWebhook",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      gaiaWebhook: { required: false, type: "UpdateGaiaWebhookInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultGaiaWebhookSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateGaiaWebhooks",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateGaiaWebhooksInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultGaiaWebhookSelection
  },
  {
    type: "action",
    operationName: "deleteGaiaWebhook",
    operationReturnType: "DeleteGaiaWebhook",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteGaiaWebhooks",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertGaiaWebhook",
    operationReturnType: "UpsertGaiaWebhook",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      gaiaWebhook: { required: false, type: "UpsertGaiaWebhookInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateGaiaWebhookResult": { hasReturnType: false },
      "... on UpdateGaiaWebhookResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultGaiaWebhookSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertGaiaWebhooks",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertGaiaWebhooksInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultGaiaWebhookSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "gaiaWebhookGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const GaiaWebhookManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultGaiaWebhookSelection,
  operations
);
export {
  DefaultGaiaWebhookSelection,
  GaiaWebhookManager
};
//# sourceMappingURL=GaiaWebhook.js.map
